@if(details()?.availMeetings; as meetings){
<schedule-viewer-part [userType]="'Applicant'" [meetings]="meetings" [blockoutSlots]="blockoutSlots()"
	[timeZoneId]="details()?.participant?.standardFourTimeZoneId" [canEdit]="canEdit()" (saved)="dialogDataService.reloadData()">
</schedule-viewer-part>
} @else {
<common-message alertType='info'>
	No Schedule Information Available
</common-message>
}